export const SORT_DIR = {
	ASC: 'asc',
	DESC: 'desc',
};

export const initialQuery = {
	page: 1,
	per_page: null,
	filters: {
		keywords: '',
		newOffers: false,
		strongOffers: false,
	},
	sort: {
		order_by_most_recent_activity: false,
		order_by_price: false,
		order_by_starting_bid_amount: false,
		direction: null,
	},
};

export const initialState = {
	metadata: {
		page: null,
		page_count: null,
		per_page: null,
		total_count: null,
	},
	loading: false,
	success: undefined,
	errors: {
		dataErrorMessage: '',
		updateErrorsByVehicle: {},
	},
	updateResponseReceivedByVehicle: {},
	query: initialQuery,
};

export const FILTERS_STORAGE_KEY = 'bulkEditURLStorage';
export const SORTING_KEYS = ['order_by_', 'direction'];

export const REJECT_ERROR = 'Failed to fetch bulk vehicles';

// fields we allow to update via websocket patches
export const WS_ALLOWED_FIELDS = [
	'most_recent_activity',
	'effective_starting_bid_amount',
	'floor_price',
	'high_floor_suggestion',
	'financial_datum',
	'offers_count',
	'has_new_offer',
	'has_strong_offer',
	'unique_views_count',
	'watched_vehicles_count',
];
